import { combineReducers } from 'redux';

import app from './app/reducer';
import appProviderKeyListWDates from './app/providerKeyListWDates/reducer';
import appUserProfile from './app/userProfile/reducer';
import appIPA from './app/ipa/reducer';
import appAnnouncements from './app/announcements/reducer';
import appPortal from './app/portal/reducer';
import appMemberReports from './app/memberReport/reducer';
import parameter from './parameter/reducer';
import aco from './app/aco/reducer';
import hmo from './app/hmo/reducer';
import powerBI from './app/powerBI/reducer';
import auth from 'store/auth/reducer';
import authProvider from './authorization/provider/reducer';
import authHistory from './authorization/history/reducer';
import authMember from './authorization/member/reducer';
import authList from './authorization/list/reducer';
import authSpecialists from './authorization/specialists/reducer';
import authModifierCode from './authorization/modifierCode/reducer';
import authExpired from './authorization/expired/reducer';
import authUnused from './authorization/unused/reducer'
import authExpiryDays from './authorization/expiryDays/reducer';
import authDiagRecords from './authorization/diagRecords/reducer';
import authDiagCodes from './authorization/diagCodes/reducer';
import authPortal from './authorization/portal/reducer';
import authFacilities from './authorization/facilities/reducer';
import authPMTProv from './authorization/PMTProv/reducer';
import authDuplicate from './authorization/duplicateAuth/reducer';
import authOBCodes from './authorization/OBCodes/reducer';
import authFiles from './authorization/files/reducer';
import authCity from './authorization/city/reducer';
import authEnquireService from './authorization/enquireService/reducer';
import authConfirmed from './authorization/submitConfirmedAuth/reducer';
import authReferType from './authorization/referType/reducer';
import authTempAuthNumber from './authorization/tempAuthNumber/reducer';
import authMediCal from './authorization/mediCal/reducer';
import authAttach from './authorization/attach/reducer';
import authExtendAndModify from './authorization/extendAndModify/reducer';
import authLetter from './authorization/letter/reducer';
import authCPSP from './authorization/cpsp/reducer';
import authFaxes from './authorization/faxes/reducer';
import authRuleCodes from './authorization/ruleCodes/reducer';
import authSurvey from './authorization/survey/reducer';
import authHCC from './authorization/hcc/reducer';
import authPOS from './authorization/pos/reducer';
import breadcrumb from './breadcrumb/reducer';
import claim from './claim/reducer';
import claimPortal from './claim/portal/reducer';
import claimNPI from './claim/npi/reducer';
import claimProviderList from './claim/providerList/reducer';
import claimMember from './claim/member/reducer';
import claimCPTCodes from './claim/cptCodes/reducer';
import claimNDC from './claim/ndc/reducer';
import claimBatchReports from './claim/batchReports/reducer';
import eligibility from './eligibility/reducer';
import eligibilityClaimGenerator from './eligibility/claimGenerator/reducer';
import eligibilityCopay from './eligibility/copay/reducer';
import eligibilityLMP from './eligibility/lmp/reducer';
import eligibilityEDD from './eligibility/edd/reducer';
import eligibilityRAFScore from './eligibility/rafScore/reducer';
import eligibilityHealth from './eligibility/health/reducer';
import eligibilityMeasures from './eligibility/measures/reducer';
import eligibilityDocuments from './eligibility/documents/reducer';
import eligibilityNoteDocs from './eligibility/noteDocs/reducer';
import eligibilityCarePlan from './eligibility/carePlan/reducer';
import eligibilityGAP from './eligibility/gap/reducer';
import eligibilityImmunization from './eligibility/immunization/reducer';
import eligibilityHCC from './eligibility/hcc/reducer';
import eligibilityEncounter from './eligibility/encounter/reducer';
import eligibilityCaseDoc from './eligibility/caseDoc/reducer';
import eligibilityMCP from './eligibility/mcp/reducer';
import eligibilityPAC from './eligibility/pac/reducer';
import eligibilityMembers from './eligibility/members/reducer';
import helpCenter from './app/helpCenter/reducer';
import measure from './measure/reducer';
import metrics from './metrics/reducer';

export default combineReducers({

  // App
  app,
  appProviderKeyListWDates,
  appUserProfile,
  appIPA,
  appAnnouncements,
  appPortal,
  appMemberReports,

  parameter,
  aco,
  hmo,
  powerBI,
  // Authentication
  auth,

  // Authorization
  authProvider,
  authHistory,
  authMember,
  authList,
  authSpecialists,
  authModifierCode,
  authExpiryDays,
  authDiagRecords,
  authDiagCodes,
  authPortal,
  authFacilities,
  authPMTProv,
  authDuplicate,
  authOBCodes,
  authFiles,
  authCity,
  authExpired,
  authUnused,
  authEnquireService,
  authConfirmed,
  authReferType,
  authTempAuthNumber,
  authMediCal,
  authAttach,
  authExtendAndModify,
  authLetter,
  authCPSP,
  authFaxes,
  authRuleCodes,
  authSurvey,
  authHCC,
  authPOS,

  //breadcrumb
  breadcrumb,

  // Claim
  claim,
  claimPortal,
  claimNPI,
  claimProviderList,
  claimMember,
  claimCPTCodes,
  claimNDC,
  claimBatchReports,

  // Member Search
  eligibility,
  eligibilityClaimGenerator,
  eligibilityCopay,
  eligibilityLMP,
  eligibilityEDD,
  eligibilityRAFScore,
  eligibilityHealth,
  eligibilityMeasures,
  eligibilityDocuments,
  eligibilityNoteDocs,
  eligibilityCarePlan,
  eligibilityGAP,
  eligibilityImmunization,
  eligibilityHCC,
  eligibilityEncounter,
  eligibilityCaseDoc,
  eligibilityMCP,
  eligibilityPAC,
  eligibilityMembers,

  helpCenter,

  // Measures
  measure,

  // Metrics
  metrics,
});
